@if (title) {
  <h2 mat-dialog-title>{{ title }}</h2>
}
<div mat-dialog-content style="min-height: 650px">
  <!-- Search field -->
  @if (!useV4Apis) {
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-icon matIconPrefix class="align-middle">search</mat-icon>
      <mat-label for="qa-search-users">{{ 'Search' | translate: locale.language }}</mat-label>
      <input matInput type="text" id="qa-search-users" [formControl]="userSearchControl" />
      @if (userSearchControl.value) {
        <button
          matIconSuffix
          mat-icon-button
          [attr.aria-label]="'Clear' | translate: locale.language"
          (click)="userSearchControl.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }

  @if (useV4Apis) {
    <app-filtered-search
      [fields]="filterByFields"
      (filterChange)="onFilterChange($event)"
      (searchChange)="onSearchChange($event)"
      [defaultFilters]="inheritedFilters"></app-filtered-search>
  }

  <!-- loading spinner -->
  <div style="min-height: 4px">
    <app-loading
      [isCircle]="false"
      [hasLoaded]="!!lastResponse"
      [hasFailed]="loadUsersFailed"
      (retryClicked)="loadUsersPage()"></app-loading>
  </div>

  <!-- paginated list of items -->
  @if (lastResponse?.items) {
    <div>
      <ul class="collection qa-user-collection" id="usersList">
        @for (user of lastResponse.items; track user.getStableId()) {
          <li
            app-selector-row
            id="userRow"
            [title]="user.displayName"
            [viewType]="'groups'"
            [showDrilldown]="false"
            [(selected)]="user.selected"
            (selectedChange)="onUserSelected(user, $event)"
            icon="person"
            [readonly]="user.readonly"></li>
        }
      </ul>
      @if (lastResponse.totalItemCount > lastResponse.pageSize) {
        <mat-paginator
          #paginator
          id="user"
          [length]="lastResponse.totalItemCount"
          [pageSize]="lastResponse.pageSize"
          [pageIndex]="lastResponse.page - 1"
          [hidePageSize]="true"
          (page)="onUserPageChange($event.pageIndex + 1)">
        </mat-paginator>
      }
    </div>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button id="cancel" color="primary" cdkFocusInitial (click)="onCancelClick()">
    {{ cancelButtonLabel | translate: locale.language }}
  </button>
  @if (!isSingleSelect) {
    <button mat-raised-button id="save" color="primary" (click)="onSaveClick()">
      {{ saveButtonLabel | translate: locale.language }}
    </button>
  }
</div>
